import { useState, useEffect } from 'react';
import PhaseService from '../service/PhaseService';

export function useGetPhase() {
  const [phaseList, setphaseList] = useState([]);

  const loadApi = async () => {
    await PhaseService.getAll()
      .then((response) => {
        if (response.data.data.length > 0) {
          let phaseOptionsList = response.data.data.map((fase) => {
            return { oportunnityPhase: fase.id, label: fase.nome };
          });

          setphaseList(phaseOptionsList);
        }
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  };

  useEffect(() => {
    loadApi();
  }, []);

  return {
    phaseList,
    setphaseList
  };
}
